(function (angular) {

  angular.module("alk.geocode", []);

})(window.angular);

require("./geocode.service");



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-geocode/module.js